// 定义页面操作的常量
export const OPT_VERTICAL_MEDIUM = "opt.vertical.medium";
export const EVENT_FULL_SCREEN_LOADING = "event.full.screen.loading.text";
// webscoket标识
export const WS_VERTICAL_MEDIUM_STATUS = "CHANNEL_STATUS"; // 垂媒渠道登录状态

export * from "./objects";
